/**
 * @author เต้ย
 * @description Keyboard Shortcuts — hotkey ลัดสำหรับ power user
 * โหลดทุกหน้า ไม่ทำงานเมื่อ focus อยู่ใน input/textarea/select
 */

class KeyboardShortcuts {
    constructor() {
        this.overlayVisible = false;
        this.shortcuts = [
            { keys: 'Ctrl+N', desc: 'สร้าง ticket ใหม่', scope: 'หน้า ticket' },
            { keys: 'Ctrl+S', desc: 'บันทึก', scope: 'เมื่อ modal เปิด' },
            { keys: 'Ctrl+/', desc: 'แสดง/ซ่อน shortcuts', scope: 'ทุกหน้า' },
            { keys: 'Alt+K', desc: 'มุมมอง Kanban', scope: 'หน้า ticket' },
            { keys: 'Alt+T', desc: 'มุมมอง Table', scope: 'หน้า ticket' },
            { keys: 'Escape', desc: 'ปิด modal / overlay', scope: 'ทุกหน้า' },
        ];
        this.createOverlay();
        this.addEventListener();
    }

    /**
     * ตรวจสอบว่า focus อยู่ใน input/textarea หรือไม่
     */
    isTyping() {
        const el = document.activeElement;
        if (!el) return false;
        const tag = el.tagName.toLowerCase();
        return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable;
    }

    /**
     * ตรวจสอบว่าเป็น Mac หรือไม่
     */
    isMac() {
        return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    }

    /**
     * ตรวจสอบว่ากด Ctrl (หรือ Cmd บน Mac)
     */
    isCtrl(e) {
        return this.isMac() ? e.metaKey : e.ctrlKey;
    }

    addEventListener() {
        const _this = this;

        $(document).on('keydown', function (e) {
            // Ctrl+/ หรือ Cmd+/ — แสดง shortcuts help (ทำงานเสมอ)
            if (_this.isCtrl(e) && e.key === '/') {
                e.preventDefault();
                _this.toggleOverlay();
                return;
            }

            // Escape — ปิด overlay ก่อน แล้วค่อยปิด modal
            if (e.key === 'Escape') {
                if (_this.overlayVisible) {
                    _this.hideOverlay();
                    e.preventDefault();
                    return;
                }
                // ปล่อยให้ Bootstrap จัดการปิด modal
                return;
            }

            // ถ้า overlay เปิดอยู่ ไม่ทำ shortcut อื่น
            if (_this.overlayVisible) return;

            // ถ้ากำลังพิมพ์ใน input ไม่ทำ shortcut (ยกเว้น Ctrl+S)
            if (_this.isTyping() && !(_this.isCtrl(e) && e.key === 's')) return;

            // Ctrl+N / Cmd+N — สร้าง ticket ใหม่
            if (_this.isCtrl(e) && e.key === 'n') {
                e.preventDefault();
                const modal = document.getElementById('modal-add-ticket');
                if (modal) {
                    const bsModal = bootstrap.Modal.getOrCreateInstance(modal);
                    bsModal.show();
                }
                return;
            }

            // Ctrl+S / Cmd+S — บันทึก
            if (_this.isCtrl(e) && e.key === 's') {
                e.preventDefault();
                // หาปุ่มบันทึกใน modal ที่เปิดอยู่
                const openModal = document.querySelector('.modal.show');
                if (openModal) {
                    const saveBtn = openModal.querySelector("[type='submit'], .btn-save, #btn-save-ticket");
                    if (saveBtn) saveBtn.click();
                }
                return;
            }

            // Alt+K — Kanban view
            if (e.altKey && e.key === 'k') {
                e.preventDefault();
                const btn = document.getElementById('btn-kanban-view');
                if (btn) btn.click();
                return;
            }

            // Alt+T — Table view
            if (e.altKey && e.key === 't') {
                e.preventDefault();
                const btn = document.getElementById('btn-table-view');
                if (btn) btn.click();
                return;
            }
        });
    }

    /**
     * สร้าง overlay แสดง shortcuts
     */
    createOverlay() {
        const modKey = this.isMac() ? '⌘' : 'Ctrl';

        let rows = '';
        this.shortcuts.forEach((s) => {
            const displayKeys = s.keys.replace('Ctrl', modKey);
            rows += `
                <tr>
                    <td><kbd class="bg-dark text-white px-2 py-1 rounded">${displayKeys}</kbd></td>
                    <td>${s.desc}</td>
                    <td class="text-muted small">${s.scope}</td>
                </tr>
            `;
        });

        const html = `
            <div id="shortcuts-overlay" class="d-none" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:9999;display:flex;align-items:center;justify-content:center;">
                <div class="card" style="max-width:500px;width:90%;">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="mb-0">Keyboard Shortcuts</h4>
                        <button type="button" class="btn btn-sm btn-icon btn-light" id="btn-close-shortcuts">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-row-bordered mb-0">
                            <thead>
                                <tr class="fw-bold text-muted bg-light">
                                    <th class="ps-4" style="width:130px;">ปุ่มลัด</th>
                                    <th>การทำงาน</th>
                                    <th style="width:120px;">ขอบเขต</th>
                                </tr>
                            </thead>
                            <tbody>${rows}</tbody>
                        </table>
                    </div>
                    <div class="card-footer text-center text-muted small">
                        กด <kbd class="bg-dark text-white px-1 rounded">${modKey}+/</kbd> เพื่อซ่อน
                    </div>
                </div>
            </div>
        `;

        $('body').append(html);

        const _this = this;
        $(document).on('click', '#btn-close-shortcuts', function () {
            _this.hideOverlay();
        });

        $(document).on('click', '#shortcuts-overlay', function (e) {
            if (e.target.id === 'shortcuts-overlay') {
                _this.hideOverlay();
            }
        });
    }

    toggleOverlay() {
        if (this.overlayVisible) {
            this.hideOverlay();
        } else {
            this.showOverlay();
        }
    }

    showOverlay() {
        const overlay = document.getElementById('shortcuts-overlay');
        if (overlay) {
            overlay.classList.remove('d-none');
            overlay.style.display = 'flex';
            this.overlayVisible = true;
        }
    }

    hideOverlay() {
        const overlay = document.getElementById('shortcuts-overlay');
        if (overlay) {
            overlay.classList.add('d-none');
            overlay.style.display = 'none';
            this.overlayVisible = false;
        }
    }
}

$(document).ready(function () {
    const keyboardShortcuts = new KeyboardShortcuts();
});
